import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { TWebsiteBuilderContainerData, TWebsiteBuilderContainerSettings, TWebsiteBuilderContainerType } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { containerTraversal } from "../../actionHelpers/containerTraversal";

type TPickContainerTypeAndSettings<T> = T extends {
  type: TWebsiteBuilderContainerType;
  settings: TWebsiteBuilderContainerSettings;
}
  ? Pick<T, "type" | "settings">
  : never;

export type TUpdatedContainerSettings = TPickContainerTypeAndSettings<TWebsiteBuilderContainerData>;

export interface IUpdateContainerSettingsActionPayload {
  id: string;
  prevContainerSettings: TUpdatedContainerSettings;
  nextContainerSettings: TUpdatedContainerSettings;
}

export interface IUpdateContainerSettingsAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS;
  payload: IUpdateContainerSettingsActionPayload;
}

export function getUpdateContainerSettingsInverseAction(
  action: IUpdateContainerSettingsAction,
): IUpdateContainerSettingsAction {
  const { id, nextContainerSettings, prevContainerSettings } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevContainerSettings: cloneDeep(nextContainerSettings),
      nextContainerSettings: cloneDeep(prevContainerSettings),
    },
  };
}

export function applyUpdateContainerSettingsChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateContainerSettingsAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextContainerSettings } = action.payload;

  return containerTraversal(header, root, footer, id, cloneDeep(nextContainerSettings));
}